import QuantityTakeoffIcon from '@resources/icons/QuantityTakeOffAggregateIcon.svg?react';
import {
  OpenWidgetCommand,
  TeiaViewerSourceType,
  ToolbarItem,
  useTeiaSource,
  useTeiaViewerContext,
  useViewerPlugin,
  useViewerSelection,
  useWidgetInfo,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';
import { uuidsToAdvancedSearch } from './utils/uuidsToAdvancedSearch';

export const ShowTeiaQuantityTakeoffWidgetToolbarItem = () => {
  const { t } = usePluginTranslation();
  const { viewer } = useTeiaViewerContext();
  const { selection } = useViewerSelection();
  const { plugin } = useViewerPlugin('qto');
  const twin = useTeiaSource(TeiaViewerSourceType.Twin);
  const { isOpened } = useWidgetInfo('TeiaQuantityTakeOff');

  const QTO_MAX_OBJECTS_SELECTION_SIZE = plugin.settings.maxObjectsLimit.value;
  const onClick = () => {
    if (!twin) {
      return;
    }
    const command = new OpenWidgetCommand(viewer, 'TeiaQuantityTakeOff', {
      searchRules: uuidsToAdvancedSearch(viewer.scene.objectSelection.getUuids()),
    });
    command.execute();
  };

  const isMaxObjectsLimitExceeded = selection.length > QTO_MAX_OBJECTS_SELECTION_SIZE;

  return (
    <ToolbarItem
      disabled={twin === null || isMaxObjectsLimitExceeded}
      icon={QuantityTakeoffIcon}
      onClick={onClick}
      label={
        isMaxObjectsLimitExceeded
          ? t('quantity_takeoff_plugin.footer_info_text', {
            limit: QTO_MAX_OBJECTS_SELECTION_SIZE,
          })
          : t('toolbar.quantity_takeoff.tooltip')
      }
      active={isOpened}
      data-dd-action-name="toolbar.quantity_takeoff"
    />
  );
};
